export const DsNavbar = {
  extends: 'Navbar',
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  transform: 'translate3d(0, -50%, 0)',
  left: '--canvas-gutter',
  flow: 'y',
  padding: 'U1 U1',
  round: 'radiusPill',
  gap: 'X',
  theme: 'canvas-card-glass',
  NavbarButtonSet: {
    padding: '0',
    gap: 'Z',
    flow: 'y',
    childProps: {
      padding: 'Y2',
      round: 'radiusPill',
      isActive: (el) => el.getWindow('explorer') === el.key,
      onClick: (ev, el) => el.call('handleDsNavbarClick')
    },
    children: [
      {
        key: 'components',
        title: (el) => el.call('polyglot', 'editor.quickAdd.component2'),
        Icon: {
          name: 'grid'
        }
      },
      {
        key: 'pages',
        title: (el) => el.call('polyglot', 'editor.command.category.pages'),
        Icon: {
          name: 'pages outline'
        }
      },
      {
        key: 'functions',
        title: (el) => el.call('polyglot', 'editor.panel.functions'),
        Icon: {
          name: 'fn outline'
        }
      },
      {
        key: 'files',
        title: (el) => el.call('polyglot', 'shell.app.files'),
        Icon: {
          name: 'folder outline'
        }
      },
      {
        key: 'dependencies',
        title: (el) => el.call('polyglot', 'editor.panel.dependencies'),
        Icon: {
          name: 'npm outline'
        }
      }
    ],
    childrenAs: 'props'
  },
  Line: {
    margin: 'Y1 0',
    width: 'fill-available'
  },
  NavbarButtonSet_ds: {
    padding: '0',
    gap: 'Z',
    flow: 'y',
    childProps: {
      padding: 'Y2',
      round: 'radiusPill',
      isActive: (el) => el.getWindow('explorer') === el.key,
      onClick: (ev, el) => el.call('handleDsNavbarClick')
    },
    children: [
      {
        key: 'color',
        title: (el) => el.call('polyglot', 'editor.panel.colors'),
        Icon: {
          name: 'color outline colored'
        }
      },
      {
        key: 'typography',
        title: (el) => el.call('polyglot', 'editor.panel.typography'),
        Icon: {
          name: 'typography outline colored'
        },
        opacity: '.7'
      },
      {
        key: 'spacing',
        title: (el) => el.call('polyglot', 'editor.panel.spacing'),
        Icon: {
          name: 'space outline colored'
        },
        opacity: '.7'
      },
      {
        key: 'icons',
        title: (el) => el.call('polyglot', 'editor.panel.icons'),
        Icon: {
          name: 'icons outline colored'
        }
      },
      {
        key: 'shape',
        title: (el) => el.call('polyglot', 'editor.panel.shapes'),
        Icon: {
          name: 'shape outline colored'
        }
      },
      {
        key: 'media',
        title: (el) => el.call('polyglot', 'editor.panel.responsive'),
        Icon: {
          name: 'device mobile half fill'
        },
        opacity: '.7'
      },
      {
        key: 'cases',
        title: (el) => el.call('polyglot', 'editor.panel.cases'),
        Icon: {
          name: 'boolean outline'
        }
      }
    ],
    childrenAs: 'props'
  },
  Line_2: {
    margin: 'Y1 0',
    width: 'fill-available'
  },
  NavbarButtonSet_meta: {
    padding: '0',
    gap: 'Z',
    flow: 'y',
    Expand: {
      title: (el) => el.call('polyglot', 'shell.voice.expand'),
      icon: 'arrowAngleRight',
      onClick: (ev, el) => {
        el.toggleWindow('explorer')
      }
    }
  },
  NavbarTooltip: {
    ignoreChildProps: true,
    ignoreChildExtends: true,
    top: '0',
    left: '110%',
    tooltipPosition: 'right',
    shapeDirection: 'left'
  }
}
